import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index.js";
import Boton from "./Boton";
import add from "./img/add.png";
import { Evaluacion } from "./contexto/ClasesGrales";
import { Scrudo } from "./general.js";

export default function CRUDcategorias() {
  let { firebase } = useContext(AppContext);

  const [evaluacion, setEvaluacion] = useState(firebase.dataEvaluacion);
  const [change, setChange] = useState(false)

  useEffect(() => {
    setEvaluacion(firebase.dataEvaluacion);
  }, [firebase.dataEvaluacion]);

  function actualizarEvaluacion() {
    firebase.actualizarEvaluacion(evaluacion);
    setChange(false)
  }

  return (
    <div>
      <div style={{ ...Scrudo, margin: "30px 30px 10px 30px" }}>
        <div style={Sevaluaciones}>
          {evaluacion.map((e, ind) => (
            <div style={Sevaluacion} key={ind}>
              <select
                value={e.id}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  let aux = [...evaluacion];
                  aux[ind].id = e.currentTarget.value;
                  setEvaluacion([...aux]);
                }}
              >
                <option value="Alcance">Alcance</option>
                <option value="Cronograma">Cronograma</option>
                <option value="Recursos">Recursos</option>
              </select>
              <input
                value={e.pregunta}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  let aux = [...evaluacion];
                  aux[ind].pregunta = e.currentTarget.value;
                  setEvaluacion([...aux]);
                }}
              ></input>
              <select
                value={e.impacto}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  let aux = [...evaluacion];
                  aux[ind].impacto = e.currentTarget.value;
                  setEvaluacion([...aux]);
                }}
              >
                <option value="rojo">rojo</option>
                <option value="amarillo">amarillo</option>
              </select>
              <select
                value={e.respuesta}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  let aux = [...evaluacion];
                  aux[ind].respuesta = e.currentTarget.value;
                  setEvaluacion([...aux]);
                }}
              >
                <option value="s">SI</option>
                <option value="n">NO</option>
              </select>
            </div>
          ))}
        </div>

      </div>
      <div style={{ display: "flex", flexDirection: "row", margin: "0px 0px 0px 30px", justifyContent: "space-between" }}>
        <Boton accion={actualizarEvaluacion} change={change} />
        <img
          src={add}
          alt="+"
          title="Agregar nueva condición"
          height="30px"
          width="30px"
          style={{ marginTop: "15px" }}
          onClick={() => {
            setEvaluacion((e) => [...e, new Evaluacion()]);
          }}
        ></img>
      </div>
    </div>
  );
}

const Sevaluaciones = {
  margin: "15px 0px 0px 30px",
  width: "74vw",
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  height: "67vh",
};

const Sevaluacion = {
  display: "grid",
  gridTemplateColumns: "12% 71% 10% 7%",
};

const SInput = {
  padding: "6px 0px 6px 2px",
  fontSize: "2vh",
  margin: "5px",
  height: "35px",
  borderRadius: "5px",
  border: "2px",
};
